// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3LNI6","filesListContainer":"PosDisputesFiles_filesListContainer__32tYJ","filesButton":"PosDisputesFiles_filesButton__3sApy"};